import React from 'react';
import {
    rootActions,
    useAppDispatch,
    useAppSelector
} from '../../data/store';
import ProductPriceFormat from '../../../../products/product-price/product-price-format';
import { CartSteps } from '../../enums/cart-steps';
import StepOverviewItem from './step-overview-item';
import { sendGAEvent } from '../../../../../domain/marketing/gtm-provider';
import FreeWithYourPurchaseOverview from '../free-with-your-purchase/free-with-your-purchase-overview';
import ConfirmOrderBtnWithoutLeftSide from '../confirm-order/confirm-order-btn-without-left-side';

const Step3OverviewWithoutLeftSide = () => {

    const dispatch = useAppDispatch();

    const cartData = useAppSelector(store => store.root.cartData);
    const priceData = cartData.priceData;

    /**
     * return to the first step
     */
    const editCartHandler = () => {
        dispatch(
            rootActions.main({
                cartStep: CartSteps.First,
            })
        );

        sendGAEvent('Edit Cart', 'Step 3');
    };


    return (
        <div className="bg-white border rounded w-full md:w-5/12 lg:w-1/4 md:top-60px sticky self-start">
            <div className="m-6">

                <div className="flex items-center justify-between font-bold mb-4">
                    <p className="text-2xl text-gray-700 mr-2">Order Summary</p>

                    <button
                        type="button"
                        onClick={ editCartHandler }
                        data-qa="cart-step3-edit-cart"
                        className="text-blue-200 font-bold text-right">
                        Edit Cart
                    </button>
                </div>

                {
                    cartData && cartData.cartItems && cartData.cartItems
                        .filter(cartItem => cartItem.isActive)
                        .map((cartItem, i) => {

                            return (
                                <StepOverviewItem
                                    key={ cartItem.cartItemGUID }
                                    cartItem={ cartItem }
                                />
                            )
                        })
                }

                <FreeWithYourPurchaseOverview />

                {
                    priceData.subTotalPrice !== priceData.totalPrice &&
                    <div className="text-gray-500 font-bold flex items-center justify-between mb-2">
                        <span className="mr-2">Subtotal</span>
                        <span className="ml-2" data-qa="cart-step3-subtotal"><ProductPriceFormat price={ priceData.subTotalPrice } /></span>
                    </div>
                }

                {
                    priceData.shipping > 0 &&
                    <div className="text-gray-500 font-bold flex items-center justify-between mb-2">
                        <span className="mr-2">Shipping</span>
                        <span className="ml-2" data-qa="cart-step3-ship-value"><ProductPriceFormat price={ priceData.shipping } /></span>
                    </div>
                }

                {
                    priceData.taxWithoutShippingTax > 0 &&
                    <div className="text-gray-500 font-bold flex items-center justify-between mb-2">
                        <span className="mr-2">Tax</span>
                        <span className="ml-2" data-qa="cart-step3-tax-value"><ProductPriceFormat price={ priceData.taxWithoutShippingTax } /></span>
                    </div>
                }

                {
                    priceData.shippingTax > 0 &&
                    <div className="text-gray-500 font-bold flex items-center justify-between mb-2">
                        <span className="mr-2">Shipping Tax</span>
                        <span className="ml-2" data-qa="cart-step3-ship-tax-value"><ProductPriceFormat price={ priceData.shippingTax } /></span>
                    </div>
                }

                {
                    priceData.totalDiscountPrice > 0 &&
                    <div className="text-green font-bold flex items-center justify-between mb-4">
                        <span className="mr-2">Discounts</span>
                        <span className="ml-2" data-qa="cart-step3-discounts-price">-<ProductPriceFormat price={ priceData.totalDiscountPrice } /></span>
                    </div>
                }

                <div className="text-3xl text-gray-700 flex items-center justify-between mb-4">
                    <span className="mr-2">Order Total</span>
                    <span className="ml-2" data-qa="cart-step3-total"><ProductPriceFormat price={ priceData.totalPrice } /></span>
                </div>

                {/*{ isConfirmationMsgVisible(cartData) && <FreePluginBox /> }*/}
                
                {/*<ConfirmText />*/}

                <div className="text-gray-700 mb-4 mt-10 text-sm">
                   <p>
                       This plan provides 5 free Voice ReGen credits a month. Each credit equals one minute of audio processing; files are rounded up to the next full minute. Credits are reset monthly. You acknowledge that you have read and agree to the <a href="/legal/waves-terms-of-use">Waves Terms of Use</a>.
                   </p>
                </div>

                <ConfirmOrderBtnWithoutLeftSide />
            </div>
        </div>
    )
};

export default Step3OverviewWithoutLeftSide;
